

export default function DsmDemo() {
    return (
        <div class="container">
            <img style={{ width: "60vw", height: "auto" }} src={"dsm-clan.svg?t=" + performance.now()} alt="DSM Clan" />
        </div>
    );
}